class CartNotification {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this.name = 'CartNotification'
        this._text = elem.querySelector('[data-cart-notification-product]')
        this._countdown = 250
        this.cart = document.querySelector('.site-header__actions__cart')
    }

    onInit () {

    }
    open (product) {
        this._countdown = 250
        this._text.innerHTML = product
        this._elem.classList.add('active')
        if (this.cart.classList.contains('site-header__actions__cart--has-items')) {

        } else {
            this.cart.classList.add('site-header__actions__cart--has-items')
        }
        requestAnimationFrame(() => { this.wait() })
    }
    wait () {
        if (this._countdown > 0) {
            this._countdown--
            requestAnimationFrame(() => { this.wait() })
        } else {
            this.close()
        }
    }
    close () {
        this._elem.classList.remove('active')
    }
}

export default CartNotification



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CartNotification.js